import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from "@angular/router";
import { ResetPasswordRequest } from "./reset-password-request";
import { AdminService } from "../../service/admin.service";
import { UtilService } from "../../service/util.service";
import * as constants from '../../app.constants';

declare let $: any;

@Component({
    selector: 'reset-password',
    template: require('./reset-password.component.html'),
    styles: [require('./reset-password.component.css')]
})
export class ResetPasswordComponent implements OnInit, AfterViewInit {

    model: ResetPasswordRequest;
    errorMsg: string;
    successMsg: string;

    constructor(
        private router: Router,
        private route:ActivatedRoute,
        private adminService: AdminService)
    {
        this.model = new ResetPasswordRequest();
        //this.successMsg = "Your password has been changed successfully.";
    }

    ngOnInit(): void {
        this.route.queryParams.forEach((params: Params) => {
            console.log(params)
            let resetToken = params['resetToken'];
            console.log(`resetToken=${resetToken}`);
            if(resetToken && resetToken.length > 1) {
                localStorage.setItem('isLoggedIn', 'false');
                localStorage.setItem('accessToken', resetToken);
            }
        });
    }

    ngAfterViewInit(): void {
        $("#password").focus();
    }

    resetPassword(): void {
        console.log('ResetPassword form submitted.');
        console.debug(JSON.stringify(this.model));
        this.errorMsg = null;
        if (!this.model.password || this.model.password.length < constants.MIN_PWD_LENGTH) {
            this.errorMsg = constants.messages.invalidPass;
        } else if (!this.model.confirmPassword || this.model.confirmPassword.length < constants.MIN_PWD_LENGTH) {
            this.errorMsg = constants.messages.invalidConfirmPass;
        } else if (this.model.password !== this.model.confirmPassword) {
            this.errorMsg = constants.messages.notMatchPass;
        } else {
            this.model.newPassword = this.model.password;
            // Delete non required attributes
            delete this.model['password'];
            delete this.model['confirmPassword'];

            console.debug(JSON.stringify(this.model));

            this.adminService
                .postCall(constants.URLs.changePassword, this.model, true)
                .then(res => {
                    console.log('res');
                    console.log(res);
                    if (res.status == 1 && res.response && res.response.message) {
                        this.successMsg = res.response.message;
                        this.setLocalData(res.response);
                    } else if (res.error && res.error.errors && res.error.errors.length) {
                        this.errorMsg = res.error.errors[0].message
                    } else {
                        this.errorMsg = res.error.message;
                    }
                })
                .catch((error: any) => {
                    console.error('ResetPasswordComponent- an error occurred', error);
                    this.errorMsg = error.message? error.message: constants.messages.serverError;
                });
        }
    }

    setLocalData(data): void {
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('adminId', data.user._id);
        localStorage.setItem('email', data.user.adminEmail);
        // accessToken already set in above step
    }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/auth/reset-password/reset-password.component.ts